import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_PRELOAD_SIZE } from "../../utils/constants";
import useApiClient from "../../hooks/useApiClient";
import { useState } from "react";
import { useDebouncedFunction } from "../../hooks/useDebouncedQueryParams";
import { DEBOUNCE_DELAY } from "../../utils";
import { MultiSelectDropdownSmartWrapperProps } from "../dropdowns/types";
import { QUERY_OPTIONS_LOAD_ONCE } from "../../apiUtils";
import { titleCase } from "../../utils";



interface SealogEventOptionValueDropdownProps {
    dropdownProps: MultiSelectDropdownSmartWrapperProps<string, string>;
    apiOptions: {
        eventValue?: string[],
        eventFreeTexts?: string[],
        eventOptionNames?: string[],
        hasDataAsset?: boolean,
    };
}

export const SealogEventOptionValueDropdown = ({
    apiOptions,
    dropdownProps,
}: SealogEventOptionValueDropdownProps) => {
    const api = useApiClient();
    const [debouncedSearchTerm, _setDebounceSearchTerm] = useState("");
    const setDebounceSearchTerm = useDebouncedFunction(
        _setDebounceSearchTerm,
        DEBOUNCE_DELAY
    );

    const mergedApiOptions = {
        size: DROPDOWN_PRELOAD_SIZE,
        query: debouncedSearchTerm || undefined,
        ...apiOptions
    }


    const { data: sealogEventOptionValues, isLoading: sealogEventOptionValuesAreLoading } = useQuery({
        queryKey: ["sealogEventOptionValues", Object.entries(mergedApiOptions)],
        queryFn: async () => {
            const freeTexts = await api.sealog.listUniqueSealogEventOptionValues({
                ...mergedApiOptions
            });
            return freeTexts.items;
        },
        ...QUERY_OPTIONS_LOAD_ONCE,
        enabled: !dropdownProps.isLoading,
    });

    return (
        <MultiSelectDropdown<string, string>
            label={"Event Additional Descriptions"}
            options={sealogEventOptionValues ?? []}
            selections={[]}
            isLoading={dropdownProps.isLoading || sealogEventOptionValuesAreLoading}
            renderOption={(o) => titleCase(o, true)}
            onSearchTermChange={setDebounceSearchTerm}
            mapOptionToSelection={o => o}
            {...dropdownProps}
        />
    )
}